import PropTypes from 'prop-types';
import FancyTimeStamp from '../../../../FancyTimeStamp';
import './DateSeparator.css';

const DateSeparator = ({ unixTime }) => {
  if (typeof unixTime !== 'number' || Number.isNaN(unixTime)) {
    return null;
  }

  return (
    <div className="date-separator">
      <span className="date-separator-label">
        <FancyTimeStamp unixTime={unixTime} briefDate />
      </span>
    </div>
  );
};

DateSeparator.propTypes = {
  unixTime: PropTypes.number.isRequired,
};

export default DateSeparator;
